import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";

import {ParametersService} from "../parameters.service";
import {UserService} from "../user.service";
import {NotificationConfig, NotificationDataElement} from "../../models";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SettingsNotificationsDefaultService {
    notificationConfig = new BehaviorSubject<NotificationConfig>(null);
    notificationConfig$ = this.notificationConfig.asObservable();

    constructor(
        private http: HttpClient,
        private parameters: ParametersService,
        private user: UserService,
    ) {
        this.defaultNotificationTime();
    }

    getNotificationInformation(selectedUdid: string | 0) {
        if (selectedUdid === 0) return;

        if (this.parameters.demoAccount()) {
            this.defaultNotificationTime();
            return;
        }
        this.getNotificationsTime(selectedUdid);
    }

    getNotificationsTime(selectedUdid: string): void {
        const baseUrl = `/api/v1/users/${this.user.user_id}/modules/${selectedUdid}`;

        this.http.get<NotificationDataElement[]>(`${baseUrl}/notifications/time`).subscribe((response) => {
            if (response.length > 0) {
                const notificationConfig: NotificationConfig = this.notificationConfig.getValue();

                response.forEach((row) => {
                    const fromHour = parseInt(row.from.split(':')[0]);
                    const fromMinute = parseInt(row.from.split(':')[1]);
                    const toHour = parseInt(row.to.split(':')[0]);
                    const toMinute = parseInt(row.to.split(':')[1]);
                    let type = null;

                    if (row.error) {
                        type = 'error';
                    } else if (row.warning) {
                        type = 'warning';
                    } else if (row.info) {
                        type = 'info';
                    }

                    if (type !== null) {
                        notificationConfig[type].id = row.id;
                        notificationConfig[type].enable = row.enable;
                        notificationConfig[type].from.whole = row.from.substring(0, 5);
                        notificationConfig[type].to.whole = row.to.substring(0, 5);
                        notificationConfig[type].from.hour = fromHour;
                        notificationConfig[type].from.minute = fromMinute;
                        notificationConfig[type].to.hour = toHour;
                        notificationConfig[type].to.minute = toMinute;
                        type = null;
                    }
                });

                this.notificationConfig.next(notificationConfig);
            } else {
                this.defaultNotificationTime();
            }
        });
    }

    private defaultNotificationTime() {
        this.notificationConfig.next({
            error: {
                id: 0,
                from: {hour: 7, minute: 0, whole: '07:00'},
                to: {hour: 22, minute: 0, whole: '22:00'},
                enable: true,
            },
            warning: {
                id: 0,
                from: {hour: 7, minute: 0, whole: '07:00'},
                to: {hour: 22, minute: 0, whole: '22:00'},
                enable: true,
            },
            info: {
                id: 0,
                from: {hour: 7, minute: 0, whole: '07:00'},
                to: {hour: 22, minute: 0, whole: '22:00'},
                enable: true,
            }
        });
    }
}
